import type { ThemeFunction } from 'src/shared/app/base/types/themeTypes';

export default {
  root: {
    width: '35px !important',
    height: '35px !important',
    borderRadius: '50%',
    padding: 6,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    position: 'relative',
    color: ({ theme }: ThemeFunction<unknown>) => theme.accentColor,
    backgroundColor: ({ theme }: ThemeFunction<unknown>) =>
      theme.calendarDisableButtonBackgroundColor,
    cursor: 'pointer',
  },
  active: {
    backgroundColor: ({ theme }: ThemeFunction<unknown>) => theme.accentColor,
    color: ({ theme }: ThemeFunction<unknown>) => theme.textColorReverse,
  },
};
